<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="900"
    :maskClosable="true"
    :destroyOnClose="true"
    placement="right"
    style="overflow: auto; padding-bottom: 53px"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="文章类型">
          <a-radio-group
            @change="onChangeRadio"
            v-decorator="[
              'articleType',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择文章类型' }]
              }
            ]"
          >
            <a-radio :value="1"> 文章 </a-radio>
            <a-radio :value="2"> 课程 </a-radio>
            <a-radio :value="4"> 链接 </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="文章标题">
          <a-input
            size="large"
            :max-length="100"
            style="width: 500px"
            placeholder="请输入文章标题,不超过100个字"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入文章标题,不超过100个字'
                  }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="文章作者">
          <a-input
            size="large"
            :max-length="100"
            style="width: 500px"
            placeholder="请输入文章作者"
            v-decorator="['author']"
          ></a-input>
        </a-form-item>

        <a-form-item label="封面图" v-if="articleType == 2">
          <UploadImage
            @handleFileList="url => handleImageList(url)"
            v-decorator="['bigPicurl']"
            :imgUrl="bigPicurl"
          />
        </a-form-item>

        <a-form-item label="标签" v-if="articleType == 1">
          <a-input
            size="large"
            :max-length="100"
            style="width: 500px"
            placeholder="请输入文章标签"
            v-decorator="['tag']"
          ></a-input>
        </a-form-item>

        <a-form-item label="视频" v-if="articleType == 2">
          <Upload
            :accept="'.mp4'"
            @handleFileList="handleFileList"
            @change="handleChange"
            :fileList="attachments"
            :deleteUrl="'wechatwork-content-biz/content/article/attachment/del'"
          >
          </Upload>
          <span class="pdf"
            >支持扩展名：.mp4（请上传的文件小于500M，否则上传不成功）</span
          >
        </a-form-item>

        <a-form-item
          :label="articleType == 1 ? '文章内容' : '简介'"
          v-if="articleType != 4"
        >
          <tinymce-editor
            ref="tinymceEditor"
            :teid="'articleTinymce'"
            style="width: 500px"
            @change="getMyValue"
            v-decorator="['content', { initialValue: '' }]"
          />
        </a-form-item>
        <a-form-item label="文章链接" v-if="articleType == 4">
          <a-input
            size="large"
            :max-length="100"
            style="width: 500px"
            placeholder="请输入文章链接"
            v-decorator="['sourceUrl']"
          ></a-input>
        </a-form-item>
        <a-form-item label="文章附件" v-if="articleType == 1">
          <Upload
            :accept="'.zip, .doc, .docx, .pdf, .jpg, .png'"
            @handleFileList="handleFileList"
            @change="handleChange"
            :fileList="attachments"
            :deleteUrl="'wechatwork-content-biz/content/article/attachment/del'"
          >
          </Upload>
          <span class="pdf"
            >支持扩展名：.zip, .doc, .docx, .pdf, .jpg, .png</span
          >
        </a-form-item>

        <a-form-item label="发布渠道栏目" v-if="articleType != 2">
          <a-tree-select
            size="large"
            style="width: 500px"
            ref="notice"
            :tree-data="columnChannel"
            @change="onChange"
            tree-checkable
            placeholder="请选择发布渠道栏目"
            v-decorator="[
              'channelColumnList',
              {
                rules: [
                  {
                    required: articleType != 2,
                    message: '请选择发布渠道栏目'
                  }
                ]
              }
            ]"
          />
        </a-form-item>

        <a-form-item label="发布时间">
          <a-date-picker
            size="large"
            style="width: 500px"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            v-decorator="[
              'publishTime',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择发布时间'
                  }
                ]
              }
            ]"
          />
        </a-form-item>

        <a-form-item label="可见权限" v-if="articleType != 2">
          <a-radio-group v-decorator="['articleAuth', { initialValue: 1 }]">
            <a-radio :value="1"> 全部人可见 </a-radio>
            <a-radio :value="2"> 会员可见 </a-radio>
            <a-radio :value="3"> 持有人可见 </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="可见权限" v-if="articleType == 2">
          <a-radio-group v-decorator="['articleAuth', { initialValue: 1 }]">
            <a-radio :value="1"> 所有人可见 </a-radio>
            <a-radio :value="2"> 跟随渠道栏目可见 </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="推送" v-if="articleType == 2">
          <a-radio-group v-decorator="['propeStatus', { initialValue: 1 }]">
            <a-radio :value="1"> 自动推送 </a-radio>
            <a-radio :value="2"> 手动推送 </a-radio>
            <a-radio :value="3"> 不推送 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="是否置顶">
          <a-radio-group @change="onChangeRadioTop" v-model="isTop">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number
            :min="1"
            :disabled="isTop == 1 ? true : false"
            v-decorator="['sort', { initialValue: 1 }]"
          ></a-input-number>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import pick from 'lodash.pick';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { articleAdd, noticeEdit } from '@/api/api';
import moment from 'moment';
import tinymceEditor from '@/components/tools/tinymceEditor';
import Upload from '@/components/common/Upload';
import { findTreeNodeArray } from '@/utils/common';
import { postTag } from '../../../../api/manage';
import UploadImage from '@/components/common/UploadImage';
const columnsPp = [
  {
    align: 'center',
    title: '文章标题',
    key: 'title',
    width: 400,
    scopedSlots: { customRender: 'title' }
  },
  {
    align: 'center',
    title: '产品',
    width: 200,
    scopedSlots: { customRender: 'productNameList' }
  },
  {
    align: 'center',
    title: '栏目',
    width: 160,
    scopedSlots: { customRender: 'columnNameList' }
  },
  {
    align: 'center',
    title: '操作',
    width: 100,
    scopedSlots: {
      customRender: 'operation'
    }
  }
];
export default {
  name: 'noticeManageModal',
  components: {
    JDictSelectTag,
    tinymceEditor,
    Upload,
    UploadImage
  },
  props: ['columnChannel', 'fundList'],
  data() {
    return {
      id: '',
      bigPicurl: '',
      fileType: 'file',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      showDialog: false,
      form: this.$form.createForm(this),
      title: '修改',
      width: 800,
      visible: false,
      isShow: false,
      model: {},
      confirmLoading: false,
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/contNotice/listResult',
        edit: process.env.VUE_APP_CMS_CONTENT + '/content/article/save',
        detail: process.env.VUE_APP_CMS_CONTENT + '/content/article/info'
        // uploadFiles: process.env.VUE_APP_CMS_CUSTOM + '/content/oss/upload'
      },
      showPp: false,
      originalId: '',
      ppList: [],
      columnsPp,
      zipFileList: [],
      cacheData: [],
      editingKey: '',
      columnList: [],
      attachments: [], //文件信息
      headers: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      uploadAction:
        process.env.VUE_APP_GATEWAY_URL + 'system-file-biz/resources/upload',
      fileUrlList: [], //上传列表

      //以下是课程新增
      articleType: 1, //1、文章 2、课程 4 链接
      parentId: '', //所属课程ID
      imageFile: '', //封面对象
      isTop: 0
    };
  },
  computed: {
    // uploadFiles: function() {
    //   return `${process.env.VUE_APP_GATEWAY_URL}${this.url.uploadFiles}`;
    // }
  },
  methods: {
    onChangeRadioTop(e) {
      this.isTop = e.target.value;
      if (this.isTop == 1) {
        this.form.setFieldsValue({
          sort: 1
        });
      }
    },
    //文章类型
    onChangeRadio(e) {
      this.articleType = e.target.value;
      console.log(e.target.value);
    },
    //附件删除
    handleImageList(fileList) {
      this.bigPicurl = fileList.fileUrl;
      this.imageFile = fileList;
    },
    handleChange(info) {
      console.log(info);
    },

    getMyValue(val) {
      this.form.setFieldsValue({
        content: val
      });
    },
    //发布渠道栏目
    onChange(value, label, val) {
      this.columnList = value;
      // this.columnList = [];
      // value.forEach((item, index) => {
      //   let obj = {};
      //   obj.columnName = label[index];
      //   obj.columnCode = val.allCheckedNodes[0].node.data.props.code;
      //   obj.channelCode = val.allCheckedNodes[0].node.data.props.channelCode;
      //   obj.columnId = item;
      //   this.columnList.push(obj);
      // });
      // console.log(this.columnList);
    },
    moment,
    disabledDate(current) {
      return current <= moment().endOf('second');
    },
    add(obj) {
      //课程新增
      this.bigPicurl = '';
      this.form.resetFields();
      this.model = Object.assign({}, { articleType: obj.articleType });
      this.articleType = obj.articleType;
      if (obj.articleType == 2) {
        //等于文章的时候新增
        this.parentId = obj.parentId;
      }
      this.$nextTick(() => {
        this.form.getFieldDecorator('articleType', {
          initialValue: 1,
          rules: [{ required: true, message: '请选择文章类型' }]
        });
        this.form.setFieldsValue(pick(this.model, 'articleType'));
      });

      this.visible = true;
      this.attachments = [];
    },
    edit(records) {
      this.bigPicurl = '';
      this.id = records.id;
      let params = {
        id: records.id
      };
      postTag(this.url.detail, params).then(res => {
        if (res.success) {
          let arr = [];
          let fundArr = [];

          this.attachments = res.result.attachments
            ? res.result.attachments
            : [];

          if (
            res.result.channelColumnList &&
            res.result.channelColumnList.length > 0
          ) {
            res.result.channelColumnList.forEach(item => {
              arr.push(item.columnId);
            });
          }
          if (res.result.fundList && res.result.fundList.length > 0) {
            res.result.fundList.forEach(item => {
              fundArr.push(item.fundName);
            });
          }
          this.columnList = arr;

          this.articleType = res.result.articleType || 1;
          this.parentId = res.result.parentId;
          this.bigPicurl = res.result.previewUrl;
          this.imageFile = {
            fileName: res.result.bigPicurl,
            fileUrl: res.result.previewUrl
          };
          this.$nextTick(() => {
            this.form.setFieldsValue({
              sort: res.result.sort,
              title: res.result.title,
              author: res.result.author,
              content: res.result.content,
              publishTime: res.result.publishTime,
              tag: res.result.tag,
              channelColumnList: arr,
              fundCodes: fundArr,
              articleAuth: res.result.articleAuth,
              propeStatus: res.result.propeStatus,
              bigPicurl: res.result.bigPicurl,
              articleType: res.result.articleType
            });
          });
          this.visible = true;
        }
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        let timeObj = {
          publishTime: values.publishTime
            ? moment(values.publishTime).format('YYYY-MM-DD HH:mm:ss')
            : '',
          failTime: values.failTime
            ? moment(values.failTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
        };

        this.model = {};
        let formData = Object.assign(this.model, values, timeObj);
        formData.channelColumnList = this.handleChannelData(); //this.columnList;
        formData.attachments = this.attachments;
        formData.bigPicurl = this.imageFile.fileName;

        if (this.articleType == 2) {
          //如果是课程，则赋值文章所属课程ID
          formData.parentId = this.parentId;
        }

        if (!err) {
          if (!this.id) {
            values.urls = '';
            articleAdd(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.confirmLoading = false;
                  that.$emit('ok');
                }
              })
              .finally(() => {
                that.confirmLoading = false;
                that.close();
              });
          } else {
            formData.id = this.id;
            console.log(formData);
            articleAdd(formData)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.confirmLoading = false;
                  that.$emit('ok');
                }
              })
              .finally(() => {
                that.confirmLoading = false;
                that.close();
              });
          }
        }
      });
    },
    // fileList(file) {
    //   this.zipFileList = file;
    //   console.log(file);
    // },
    handleCancel() {
      this.close();
    },
    handleFileList(fileList) {
      console.log('=============', fileList);
      let list = fileList;
      this.attachments = [];
      if (fileList && fileList.length > 0) {
        list.forEach(item => {
          let obj = {
            attachmentName: item.name,
            attachmentPath: item.fileName
          };
          this.attachments.push(obj);
        });
      } else {
        this.attachments = [];
      }
    },
    handleChannelData() {
      let arr = findTreeNodeArray('children', this.columnChannel, e => {
        return this.columnList.filter(item => item == e.id).length > 0;
      });
      console.log('arr++++++', arr);
      let list = [];
      arr.forEach(item => {
        let obj = {};
        obj.columnName = item.name;
        (obj.columnCode = item.code), (obj.channelCode = item.channelCode);
        obj.columnId = item.value;
        list.push(obj);
      });
      return list;
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.select-all {
  position: absolute;
  right: -10px;
  top: -60px;

  button {
    padding-left: 0;
  }
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
